<template>
  <!-- 收藏 -->
  <div class="Collection" @click="Coll">
    <img src="../../../public/static/images/collect.png" alt="" />
    <span v-show="collect==0">收藏</span>
    <span v-show="collect==1">已收藏</span>
  </div>
</template>

<script>
//传参，
// 当前状态、 state 是否收藏  true / false
// 项目/活动、 type  project event
// id、 项目id

import axios from "axios";
import Qs from "qs";
export default {
  name: "Collection",
  props: {
    type: String,
    id: String,
    state: Boolean,
    collect: Number,
  },
  components: {},
  methods: {
    Coll() {
      let self = this;
      if (self.type == "project") {
        self.ProjectCollection();
      } else if (self.type == "event") {
        self.EventCollection();
      }
    },
    EventCollection() {
      //云对接活动收藏
      let self = this;
      // axios.post('/api/jointactivitycollect', {
      //     activityid: self.id,//项目id
      // }).then(function (response) {
      //     if (response.data.code == 0) {
      //         // self.ProjectList = response.data.data
      //     }
      // }).catch(function (error) {
      //     console.log(error);
      // });
      let data = Qs.stringify({ activityid: self.id});
      axios({
        method: "post",
        url: '/api/jointactivitycollect',
        data:data ,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }).then((res) => {
        if (res.data.code == 0) {
              self.ProjectList = res.data.data
              console.log("活动的")
          }
      }).catch((err) => {
          console.log(err)
      })
    },
    ProjectCollection() {
      //项目收藏
      let self = this;
      let data = Qs.stringify({ projectid: self.id,});
      axios({
        method: "post",
        url: '/api/jointprojectidcollect',
        data:data ,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }).then((res) => {
        if (res.data.code == 0) {
              self.ProjectList = res.data.data
              console.log("项目的")
          }
      }).catch((err) => {
          console.log(err)
      })
    },
  },
};
</script>
<style scoped>
.Collection {
  /* margin: 9px 0 10px;
        margin-right: 24px; */
  cursor: pointer;
}

.Collection span {
  margin-left: 5px;
}
</style>